intra_module.factory('Walls', function($resource, api_url) {
    const url     = `${api_url}/walls`;
    const actions = {
        getUnreadForStaticsWall: {
            method: 'GET',
            url:    `${api_url}/walls/unread_conversations`,
            isArray: false
        },
        getTags: {
            method:  'GET',
            url:     `${url}/tags`,
            isArray: false
        }
    };

    return $resource(url, { }, actions);
});
